const NoData = () => {
    return <div className="bg-white p-4 shadow-lg rounded-md">No Data</div>;
};

export default NoData;
